var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2071 5.29289C13.5976 5.68342 13.5976 6.31658 13.2071 6.70711L9.91421 10L13.2071 13.2929C13.5976 13.6834 13.5976 14.3166 13.2071 14.7071C12.8166 15.0976 12.1834 15.0976 11.7929 14.7071L7.79289 10.7071C7.40237 10.3166 7.40237 9.68342 7.79289 9.29289L11.7929 5.29289C12.1834 4.90237 12.8166 4.90237 13.2071 5.29289Z",
    fill: "#4B5563"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-left.a67f4d2348c26cb78b510d876c2b103c.svg";